<script>
	export let value;
	export let max;
</script>



<main
	style="--bar_value: {value*100/max}%"
>
	
</main>



<style>
	main {
		height: 1px;
		background-color: #ffaa00;
		width: var(--bar_value);
		transition: width 1s linear;
		opacity: 0.5;
	}
</style>